import { lazy } from 'react';
import { RouteConfig } from '@bobex/react-core/routes/RouteConfig';

export const protectedRoutes: RouteConfig[] = [
  {
    key: 'Dashboard',
    path: 'dashboard',
    component: lazy(() => import('@/pages/Dashboard/Dashboard')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'UserDetails',
    path: 'user/:userId/:tabValue',
    component: lazy(() => import('@/pages/Users/UserDetailsPage')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'GovexProfileDetail',
    path: 'user/:userId/govexprofile/:profileId/:tab?',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileDetail')),
    authority: ['READ_GOVEXPROFILEMODEL'],
  },
  {
    key: 'GovexProfileEdit',
    path: 'user/:userId/govexprofile/:profileId/edit',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileEdit')),
    authority: ['UPDATE_GOVEXPROFILEMODEL'],
  },
  {
    key: 'GovexProfileCreate',
    path: 'user/:userId/govexprofile/create',
    component: lazy(() => import('@/pages/Users/GovexProfile/GovexProfileEdit')),
    authority: ['UPDATE_GOVEXPROFILEMODEL'],
  },

  {
    key: 'GovexSubscriptionRenewals',
    path: 'subscription_renewals',
    component: lazy(() => import('@/pages/Subscriptions/GovexSubscriptionRenewalsPage')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'GovexSubscriptionRenewalsTest',
    path: 'subscription_renewals_test',
    component: lazy(() => import('@/pages/Subscriptions/GovexSubscriptionRenewalsPage')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'MonthlyTargets',
    path: 'monthly-targets',
    component: lazy(() => import('@/pages/MonthlyTargets/MonthlyTargets')),
    authority: ['READ_INVOICE', 'VIEW_CHARTS'],
  },
  {
    key: 'InvoicesByVendor',
    path: 'invoices-by-vendor',
    component: lazy(() => import('@/pages/InvoicesByVendor/InvoicesByVendorPage')),
    authority: ['READ_INVOICE', 'VIEW_CHARTS'],
  },
  {
    key: 'PaymentsDashboard',
    path: 'payments-dashboard',
    component: lazy(() => import('@/pages/PaymentsDashboard/PaymentsDashboard')),
    authority: ['VIEW_CHARTS_ADMIN'],
  },
  {
    key: 'LawyerDashboard',
    path: 'lawyer-dashboard',
    component: lazy(() => import('@/pages/LawyerDashboard/LawyerDashboard')),
    authority: ['READ_LAWYER_DASHBOARD'],
  },
  {
    key: 'InvoiceVsPaid',
    path: 'invoice-vs-paid',
    component: lazy(() => import('@/pages/InvoiceVsPaid/InvoiceVsPaid')),
    authority: ['VIEW_CHARTS_ADMIN'],
  },
  {
    key: 'SearchUser',
    path: 'search-user',
    component: lazy(() => import('@/pages/SearchUser/SearchUser')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'SearchSubscription',
    path: 'search-subscription',
    component: lazy(() => import('@/pages/SearchSubscription/SearchSubscription')),
    authority: ['READ_INVOICE'],
  },
  {
    key: 'Send to Lawyer',
    path: 'send-to-lawyer',
    component: lazy(() => import('@/pages/SendToLawyer/SendToLawyer')),
    authority: ['READ_SEND_TO_LAWYER'],
  },
  {
    key: 'ChartsHome',
    path: 'charts-home',
    component: lazy(() => import('@/pages/ChartsHome/ChartsHome')),
    authority: ['VIEW_CHARTS', 'READ_INVOICE'],
  },
  {
    key: 'Sitemap',
    path: 'sitemap',
    component: lazy(() => import('@/pages/Sitemap/Sitemap')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'User Similarities',
    path: 'user-similarities',
    component: lazy(() => import('@/pages/UserSimilarities/UserSimilarities')),
    authority: ['CAN_LOGIN'],
  },
  {
    key: 'BdaTools',
    path: 'bda-tools',
    component: lazy(() => import('@/pages/BdaTools/BdaTools')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'BdaLots',
    path: 'bda-lots',
    component: lazy(() => import('@/pages/BdaLots/BdaLots')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'JoueLots',
    path: 'joue-lots',
    component: lazy(() => import('@/pages/JoueLots/JoueLots')),
    authority: ['MANAGE_BDA_JOUE'],
  },
  {
    key: 'JoueTools',
    path: 'joue-tools',
    component: lazy(() => import('@/pages/JoueTools/JoueTools')),
    authority: ['MANAGE_BDA_JOUE'],
  },
];
